import { GameProvider } from "./game/GameContext";
import { VoyageRail } from "./components/game/VoyageRail";
import { Nav } from "./components/sections/Nav";
import { Hero } from "./components/sections/Hero";
import { Manifesto } from "./components/sections/Manifesto";
import { BoatPicker } from "./components/sections/BoatPicker";
import { CrewMuster } from "./components/sections/CrewMuster";
import { SameBoatNotes } from "./components/sections/SameBoatNotes";
import { BoatMap } from "./components/sections/BoatMap";
import { NoPitches } from "./components/sections/NoPitches";
import { Philosophy } from "./components/sections/Philosophy";
import { BuildWall } from "./components/sections/BuildWall";
import { WhoFor } from "./components/sections/WhoFor";
import { Curated } from "./components/sections/Curated";
import { FinalCta } from "./components/sections/FinalCta";
import { Footer } from "./components/sections/Footer";
import { AutterStoryBand } from "./components/sections/AutterStoryBand";

/**
 * The full scrolling site: the same content as a page, reachable from the
 * landing story via "read more". Offers a way back to land at the letter.
 */
export function PageSite({ onPlay }: { onPlay: () => void }) {
  return (
    <GameProvider>
      <div className="reader-page min-w-0">
        <a
          href="#main"
          className="fixed top-3 left-3 z-[60] -translate-y-20 rounded-full bg-ink px-4 py-2 text-sm font-semibold text-foam transition-transform focus:translate-y-0"
        >
          Skip to the good bit
        </a>
        <Nav onPlay={onPlay} />
        <VoyageRail />
        <main id="main">
          <Hero onPlay={onPlay} />
          <Manifesto />
          <BoatPicker />
          <CrewMuster />
          <BuildWall />
          <WhoFor />
          <SameBoatNotes />
          <NoPitches />
          <Philosophy />
          <AutterStoryBand />
          <BoatMap />
          <Curated />
          <FinalCta />
        </main>
        <Footer />
      </div>
    </GameProvider>
  );
}
